export default __webpack_public_path__ + "static/media/circle-close.cfc10458.svg";